import { MultiAutocompleteOptionProps } from "@dev/ee-components";
import { useContactLists } from "../useContactLists";

export const useContactAudienceLists = (): MultiAutocompleteOptionProps[] => {
    const contactLists = useContactLists();
    return contactLists?.map((item) => ({
        ...item,
        category: '',
    }));
}
